import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import Header from '../../Header/Header'
import '../Employees/Style/Addemp.css';
import '../Employees/EditEmployee/vieweditdetails/Vieweditdetails.css';
import {  CiEdit, CiGrid41, CiLocationOn, CiMail, CiPhone, CiUser,  } from 'react-icons/ci'
// import {CiBank,CiBadgeDollar,CiCreditCard1, CiCreditCard2,CiCalendar,CiMemoPad,CiViewList} from 'react-icons/ci'
// import Sidebar from '../../../Sidebar/Sidebar'
// import api_backend from '../../Config/api'
import { useSelector } from 'react-redux'
// import userdemoimg from '../../Images/Pagesimg/userdemo'
//import { format } from 'date-fns';
import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'

const Viewedituniqueid = () => {

  const employeeDetails1 = useSelector((state) => state.employees);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (employeeDetails1 && employeeDetails1.employees.length > 0) {
      setEmployeeDetails(employeeDetails1.employees[0]);
    }
  }, [employeeDetails1]);


  const editpersonal = () => {
    navigate('/editpersonalinfo')
  }

 

  return (
    <div className='index-container'>
      <Header />
      <div className='index-content-parent'>
        <div className='index-content'>
          <Sidebar />
          {employeeDetails ?
            (
              <>
                <div className='index-content-sub'>
                  <div className='index-main'>
                    <div className='addemp-subheader'>
                      <div className='addemp-subheader-sub'>
                        <div className='vieweditdet-subheader'>
                          <p> {employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.name : "N/A"} </p>
                          <div className='vieweditdet-top-dropdown'>
                           
                          </div>
                        </div>
                       
                      </div>
                    </div>
                    <div className='addemp-line'></div>
                    <div className='addemp-maincontent-sub'>
                      <div className='addemp-form emp-edit'>
                       
                        <div className="vieweditdet-right-side">
                          <div className='vieweditdet-card1'>
                            <div className='vieweditdet-edit-icon' onClick={editpersonal}>
                              <CiEdit />
                            </div>
                            <p className='vieweditdet-heading-p-left'>PERSONAL INFO:</p>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiUser />
                              </div>
                              <p>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.name : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiPhone />
                              </div>
                              
                              <p>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.phone : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiMail />
                              </div>
                              <p>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.personal_email : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiLocationOn />
                              </div>
                              <p>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.address_line1 : "N/A"}</p>
                            </span>

                             <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiGrid41 />
                              </div>
                              <p>{employeeDetails && employeeDetails.work_location ? employeeDetails.work_location.company_name : "N/A"}</p>
                            </span>

                          </div>
                         
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </>
            )
            :
            (
              <></>
            )
          }

        </div>
      </div>
    </div>
  )
}

export default Viewedituniqueid
